import React, { useState } from "react"
import { PressReleaseContainer, Wrapper, PressReleaseCard } from "./styles"
import { graphql, useStaticQuery, Link } from "gatsby"
import { Row, Col } from "react-bootstrap"

const PressReleaseListing = ({ item }) => {
  // get press releases
  const data = useStaticQuery(PRESS_RELEASE_QUERY)
  const pressReleases = data.allAgilityPressRelease.nodes

  // set up visible press releases
  const [visible, setVisible] = useState(9)

  // function to items
  const showMoreItems = () => {
    setVisible(prevValue => prevValue + 9)
  }

  // function to truncate text
  const truncate = (str, num) => {
    if (str.length > num) {
      return str.slice(0, num) + "..."
    }
    return str
  }

  return (
    <PressReleaseContainer>
      <Wrapper>
        <h1>{item.customFields.title}</h1>
        <Row>
          {pressReleases.slice(0, visible).map((pressRelease, i) => (
            <Col lg={4} md={6} key={i}>
              <Link to={pressRelease.sitemapNode.path}>
                <PressReleaseCard>
                  <p className="date">{pressRelease.customFields.date}</p>
                  <h5>{truncate(pressRelease.customFields.title, 90)}</h5>
                  <p>Read More</p>
                </PressReleaseCard>
              </Link>
            </Col>
          ))}
        </Row>
        {pressReleases.length > visible && (
          <div className="load__more-container">
            <button className="load__more" onClick={showMoreItems}>
              Load More
            </button>
          </div>
        )}
      </Wrapper>
    </PressReleaseContainer>
  )
}

export default PressReleaseListing

const PRESS_RELEASE_QUERY = graphql`
  query {
    allAgilityPressRelease(sort: { order: DESC, fields: customFields___date }) {
      nodes {
        customFields {
          title
          date(formatString: "MMMM DD, YYYY")
          link {
            href
            target
            text
          }
        }
        sitemapNode {
          path
        }
      }
    }
  }
`
